import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import Fab from './Fab';
import '../../../assets/style/common.scss';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';

const FabGroup = (props) => {
  const history = useHistory();

  return (
    <div className="fabContainer">
      {props.buttons.map((fab, i) => (
        <React.Fragment key={i}>
          <Fab
            name={'fab-' + i}
            loading={fab.loading}
            onClick={() => {
              fab.onClickFn();
              if (fab.isClose) {
                history.goBack();
              }
            }}
            type={fab.type}
            iconOnly={fab.iconOnly}
            disabled={fab.disabled}
          >
            {fab.isClose && (
              <CloseRoundedIcon fontSize={fab.iconOnly ? 'large' : 'default'} />
            )}
            <span>{fab.title}</span>
          </Fab>
        </React.Fragment>
      ))}
    </div>
  );
};

FabGroup.propTypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      loading: PropTypes.bool,
      iconOnly: PropTypes.bool,
      title: PropTypes.string,
      type: PropTypes.oneOf(['default', 'accept', 'deny']),
      onClickFn: PropTypes.func,
      isClose: PropTypes.bool,
      disabled: PropTypes.bool
    })
  )
};

export default FabGroup;
